var _defs, _rect, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageFallback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0ea5e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#10b981"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 600,
    rx: 24,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(160,160)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 480,
    height: 320,
    rx: 16,
    fill: "#ffffff22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 424,
    height: 180,
    rx: 12,
    fill: "#ffffff55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 224,
    width: 300,
    height: 24,
    rx: 8,
    fill: "#ffffffbb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 260,
    width: 360,
    height: 20,
    rx: 8,
    fill: "#ffffff66"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60,40)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 32,
    rx: 8,
    fill: "#00000044"
  }), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 22,
    fontFamily: "Segoe UI, Roboto, Arial",
    fontSize: 16,
    fill: "#fff"
  }, "Visuel non disponible"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageFallback);
export default __webpack_public_path__ + "static/media/image-fallback.2ce0dffbf4331a1bf4082d4343f345e4.svg";
export { ForwardRef as ReactComponent };